'use strict';

module.exports = ['PENDING', 'COMPLETED', 'SETTLED', 'CANCELLED', 'ERRORED', 'SKIPPED', 'REFUNDED'];